import {
  IconAlignBottom,
  IconAlignHorizontalCenter,
  IconAlignTop,
} from '@bynder/icons';
import { Translate, useTranslate } from '@bynder/localization';
import { List, Tabs } from '@bynder/design-system';
import { ContentAlignment } from '../../../../types';
import { useActiveSection } from '../../../../queries/guides';
import { useSectionMutations } from '../../../../mutations/sections';

export const SectionAlignmentEditor = () => {
  const { translate } = useTranslate();

  const { activeSection } = useActiveSection();
  const { changeSectionAlginment } = useSectionMutations();

  const handleChangeAlignment = (newAlignment: ContentAlignment) => {
    if (activeSection.appearance.contentAlignment !== newAlignment) {
      changeSectionAlginment.mutate({
        sectionId: activeSection.id,
        newAlignment,
      });
    }
  };

  return (
    <>
      <List.Item>
        <Translate id="SECTION_INSPECTOR.WIDGET_ALIGNMENT" />
      </List.Item>
      <Tabs variant="clean">
        <Tabs.Tab
          data-testid="alignment-top"
          label={translate('SECTION_INSPECTOR.WIDGET_ALIGNMENT_TOP')}
          isLabelHidden
          isActive={
            activeSection?.appearance.contentAlignment === ContentAlignment.TOP
          }
          onClick={() => handleChangeAlignment(ContentAlignment.TOP)}
          icon={<IconAlignTop />}
        />

        <Tabs.Tab
          data-testid="alignment-center"
          label={translate('SECTION_INSPECTOR.WIDGET_ALIGNMENT_CENTER')}
          isLabelHidden
          isActive={
            activeSection?.appearance.contentAlignment ===
            ContentAlignment.CENTER
          }
          onClick={() => handleChangeAlignment(ContentAlignment.CENTER)}
          icon={<IconAlignHorizontalCenter />}
        />

        <Tabs.Tab
          data-testid="alignment-bottom"
          label={translate('SECTION_INSPECTOR.WIDGET_ALIGNMENT_BOTTOM')}
          isLabelHidden
          isActive={
            activeSection?.appearance.contentAlignment ===
            ContentAlignment.BOTTOM
          }
          onClick={() => handleChangeAlignment(ContentAlignment.BOTTOM)}
          icon={<IconAlignBottom />}
        />
      </Tabs>
    </>
  );
};
